module.exports = __webpack_public_path__ + "media/logos/dobry-wzor-badge-mail@2x-85571c17.png";